export default "__VITE_ASSET__Do62Ymyp__"